import * as types from './mutation-types';
import { defaultCfopParameterizationState } from './state';

export default {
  [types.RESET_CFOP_PARAMETERIZATION](state) {
    Object.assign(state.cfopParameterization, defaultCfopParameterizationState());
  },
  [types.SET_SUMMARY_CFOP_PARAMETERIZATIONS](state, payload) {
    state.summaryCfopParameterizations = payload;
  },
  [types.SET_PAGINATION_CFOP_PARAMETERIZATIONS](state, payload) {
    state.paginationCfopParameterizations = payload;
  },
  [types.SET_DETAILED_CFOP_PARAMETERIZATION](state, payload) {
    state.cfopParameterization = payload;
  },
};
